const DEFAULT_CHOICE_BRAND_NAME = 'Choice123123';
const DEFAULT_VIDEO_NAME = `${DEFAULT_CHOICE_BRAND_NAME}视讯`;
const DEFAULT_SPORT_NAME = `${DEFAULT_CHOICE_BRAND_NAME}体育`;
const DEFAULT_ENTRY_ICON = '/static/gameHall/live-ag.png';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const normalizeConfigValue = (value, fallback) => {
  const normalized = String(value == null ? '' : value).trim();
  return normalized || fallback;
};

const readEntryConfig = (runtimeValue, localValue, fallback) => {
  const value = IS_PRODUCTION
    ? runtimeValue || localValue || fallback
    : localValue || fallback;

  return normalizeConfigValue(value, fallback);
};

export const CHOICE_BRAND_NAME = DEFAULT_CHOICE_BRAND_NAME;

export const CHOICE_VIDEO_NAME = readEntryConfig(
  typeof window !== 'undefined' ? window.GAME_HALL_VIDEO_ENTRY_TEXT : undefined,
  process.env.VUE_APP_GAME_HALL_VIDEO_ENTRY_TEXT,
  DEFAULT_VIDEO_NAME
);

export const CHOICE_VIDEO_ICON = readEntryConfig(
  typeof window !== 'undefined' ? window.GAME_HALL_VIDEO_ENTRY_ICON : undefined,
  process.env.VUE_APP_GAME_HALL_VIDEO_ENTRY_ICON,
  DEFAULT_ENTRY_ICON
);

export const CHOICE_SPORT_NAME = readEntryConfig(
  typeof window !== 'undefined' ? window.GAME_HALL_SPORT_ENTRY_TEXT : undefined,
  process.env.VUE_APP_GAME_HALL_SPORT_ENTRY_TEXT,
  DEFAULT_SPORT_NAME
);

export const CHOICE_SPORT_ICON = readEntryConfig(
  typeof window !== 'undefined' ? window.GAME_HALL_SPORT_ENTRY_ICON : undefined,
  process.env.VUE_APP_GAME_HALL_SPORT_ENTRY_ICON,
  DEFAULT_ENTRY_ICON
);

export const PA_VIDEO_GAME_NAME = 'AG视讯';
export const PA_SPORT_GAME_NAME = 'AG体育';
